module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "featured-donate-block"
  }, [_c('div', {
    staticClass: "featured-donate-block__number"
  }, [_vm._v("\n            " + _vm._s(_vm.section.heading) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "featured-donate-block__content",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-714a8ee6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/step_block/step_block.vue
// module id = 645
// module chunks = 0